import React from 'react';

import {BenefitsListProps} from '#component/page/Profile/components/ManagePlanTab/SubscriptionManager/SubscriptionManager.types';

import {MembersBenefitsList} from './components/MembersBenefitsList';
import {SubscriptionBenefitsList} from './components/SubscriptionBenefitsList';

export const BenefitsList = ({customerType}: BenefitsListProps) => {
  return (
    <div>
      {customerType === 'membership' ? <MembersBenefitsList /> : <SubscriptionBenefitsList />}
    </div>
  );
};
